import * as types from "../types/entregadores";

const INITIAL_STATE = {
  filtro: {
    nome: "",
  },
  page: 1,
  perpage: 10,
  total: 0,
  entregadores: [],
  entregador: {
    nome: "",
    cpf: "",
    celular: "",
    email: "",
    veiculo: "BIKE",
    placa: "",
    situacao: "A",
    password: "",
  },
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_ENTREGADORES:
      return { ...state, entregadores: action.payload };
    case types.SET_PAGE_ENTREGADOR:
      return { ...state, page: action.payload };
    case types.SET_PERPAGE_ENTREGADOR:
      return { ...state, perpage: action.payload };
    case types.SET_ENTREGADORES_TOTAL:
      return { ...state, total: action.payload };
    case types.SET_LOADING_ENTREGADOR:
      return { ...state, loading: action.payload };
    case types.SET_FILTRO_ENTREGADORES:
      return {
        ...state,
        filtro: { ...state.entidade_filtro, ...action.payload },
      };
    case types.SET_ENTREGADOR:
      return { ...state, entregador: action.payload };
    default:
      return state;
  }
};
